export const ACCOUNT_SETTINGS = {
    DYNAMIC_TAX: "dynamic-tax" as const,
} as const

export const ACCOUNT_STATUS = {
    ACTIVE: "active" as const,
    DEMO: "demo" as const,
    TRIAL: "trial" as const,
    EXPIRED: "expired" as const,
} as const




// WEBPACK FOOTER //
// ./src/utils/account/constants.ts